// Warning + current assignment(s) when member has date-active UserAssignments.

import React from 'react';

function formatAssignmentDate(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString();
}

/**
 * @param {object} props
 * @param {{ hasActiveAssignment?: boolean, warning?: string|null, assignments?: object[] }|null} props.activeAssignment
 * @param {'admin'|'dashboard'} [props.variant]
 */
export default function ActiveAssignmentNotice({
  activeAssignment,
  variant = 'admin',
}) {
  if (!activeAssignment?.hasActiveAssignment) return null;

  const root =
    variant === 'dashboard' ? 'member-dashboard' : 'org-requests';

  return (
    <div className={`${root}__assignment-warning`} role="alert">
      <p className={`${root}__assignment-warning-text`}>{activeAssignment.warning}</p>
      <div className={`${root}__assignment-current`}>
        <span className={`${root}__assignment-current-label`}>Current assignment</span>
        <ul className={`${root}__assignment-current-list`}>
          {activeAssignment.assignments.map((row, index) => {
            const start = formatAssignmentDate(row.startDate);
            const end = formatAssignmentDate(row.endDate);
            const period =
              start && end ? `${start} – ${end}` : start ? `from ${start}` : null;

            return (
              <li
                key={`${row.assignment}-${row.orgDivision}-${index}`}
                className={`${root}__assignment-current-item`}
              >
                <span className={`${root}__assignment-current-name`}>{row.assignment}</span>
                {row.orgDivision ? (
                  <span className={`${root}__assignment-current-division`}>
                    {row.orgDivision}
                  </span>
                ) : null}
                {row.roleTypeName ? (
                  <span className={`${root}__assignment-current-role`}>{row.roleTypeName}</span>
                ) : null}
                {period ? (
                  <span className={`${root}__assignment-current-period`}>{period}</span>
                ) : null}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
